/* ═══════════════════════════════════════════════════════════════
   THS3 LIFE — real add-to-cart + interaction feedback
   Created 2026-08-04.

   THE LEAK THIS FIXES
   Every product card rendered a native <form> POST to /cart/add.
   Adding anything therefore threw the shopper out of the grid and
   onto /cart — a full page load, browsing context gone, and no way
   back except the back button. On a collection page that is 20
   separate ejection seats. With mobile add-to-cart at 0.18%, this
   is the single biggest structural leak on the storefront.

   Cards now add over the cart AJAX API and confirm in place, so
   the shopper keeps browsing. The PDP form is deliberately NOT
   touched: it must stay a real page submit for the personalisation
   photo upload to work (CLAUDE.md §6.4), and it carries the
   quantity-slab logic that a previous session had to fix after a
   real customer was overcharged. Scope here is strictly
   form.ths3-card-form.

   Everything degrades: no fetch, or any error at all, and the form
   submits natively exactly as it does today.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (!window.fetch || !window.FormData) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOAST_MS = reduced ? 2600 : 4200;
  var toastTimer = null;

  /* ── cart count ───────────────────────────────────────────────
     Every badge on the page is kept in sync from ONE source: the
     count the cart API actually returns. Nothing is ever guessed
     locally — that was the old simulated cart's failure mode. */
  function paintCount(n) {
    var badges = document.querySelectorAll('.hdr-cart__n, .m-tab__n, [data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      var el = badges[i];
      if (el.textContent.trim() === String(n)) continue;
      el.textContent = String(n);
      el.classList.remove('ths-bump');
      /* reflow so the animation restarts on a repeat add */
      void el.offsetWidth;
      el.classList.add('ths-bump');
    }
  }

  function refreshCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); return cart; });
  }

  /* ── toast ────────────────────────────────────────────────────
     role="status" + aria-live so it is announced without stealing
     focus from whatever the shopper was doing. */
  /* Paise -> "₹1,234". Shopify returns cart totals in the shop's minor unit, and
     the panel is worthless without a number the buyer recognises. Intl is used
     where present and a manual grouping fallback covers old WebViews. */
  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR',
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '₹' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  function ensureToast() {
    var t = document.querySelector('[data-ths-toast]');
    if (t) return t;
    t = document.createElement('div');
    t.className = 'ths-toast';
    t.setAttribute('data-ths-toast', '');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.hidden = true;
    document.body.appendChild(t);
    return t;
  }

  function showToast(opts) {
    var t = ensureToast();
    var cartUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';

    t.innerHTML = '';

    if (opts.image) {
      var img = document.createElement('img');
      img.className = 'ths-toast__img';
      img.src = opts.image;
      img.alt = '';
      img.width = 48; img.height = 48;
      t.appendChild(img);
    }

    var body = document.createElement('div');
    body.className = 'ths-toast__body';

    var head = document.createElement('p');
    head.className = 'ths-toast__head';
    head.textContent = opts.error ? opts.message : 'Added to your cart';
    body.appendChild(head);

    if (!opts.error && opts.title) {
      var sub = document.createElement('p');
      sub.className = 'ths-toast__sub';
      sub.textContent = opts.title;
      body.appendChild(sub);
    }

    /* The cart summary. Before this existed the panel confirmed an action without
       ever showing what the buyer now held, so there was nothing to act on. */
    if (!opts.error && opts.cart) {
      var sum = document.createElement('p');
      sum.className = 'ths-toast__sum';
      var n = opts.cart.item_count || 0;
      sum.textContent = n + (n === 1 ? ' item' : ' items') + ' · ' + money(opts.cart.total_price);
      body.appendChild(sum);
    }
    t.appendChild(body);

    /* THE FIX. Until now the only way onward was a "View cart" link that vanished
       after 4.2 seconds, so add-to-cart dead-ended on the collection grid: pixel
       InitiateCheckout/AddToCart fell from 37.7% to 9.1% the day the AJAX add
       shipped (4 Aug 2026), while add-to-cart volume itself held. Checkout is now
       the primary action, present the moment the item lands, and the panel does
       not time out from under the decision. */
    if (!opts.error) {
      var acts = document.createElement('div');
      acts.className = 'ths-toast__acts';

      var pay = document.createElement('a');
      pay.className = 'ths-toast__pay';
      pay.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
      pay.textContent = 'Checkout';
      acts.appendChild(pay);

      var go = document.createElement('a');
      go.className = 'ths-toast__go';
      go.href = cartUrl;
      go.textContent = 'View cart';
      acts.appendChild(go);

      t.appendChild(acts);
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ths-toast__x';
    close.setAttribute('aria-label', 'Dismiss');
    close.innerHTML =
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';
    close.addEventListener('click', hideToast);
    t.appendChild(close);

    t.classList.toggle('is-error', !!opts.error);
    t.hidden = false;
    void t.offsetWidth;
    t.classList.add('is-open');

    /* A success panel is a decision point and must not expire while it is being
       read — 4.2 seconds was shorter than the time it takes to choose. Errors are
       transient notices and still clear themselves. */
    clearTimeout(toastTimer);
    if (opts.error) toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  /* Persistent panels need a keyboard exit. Not a modal — the page stays usable
     behind it — so this is Escape only, no focus trap. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var t = document.querySelector('[data-ths-toast]');
    if (t && t.classList.contains('is-open')) hideToast();
  });

  function hideToast() {
    var t = document.querySelector('[data-ths-toast]');
    if (!t) return;
    clearTimeout(toastTimer);
    t.classList.remove('is-open');
    /* wait out the exit transition before hiding from AT */
    setTimeout(function () { if (!t.classList.contains('is-open')) t.hidden = true; }, reduced ? 60 : 260);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideToast();
  });

  /* ── button state ─────────────────────────────────────────── */
  function setLabel(btn, text) {
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        if (text === null) {
          if (btn.hasAttribute('data-idle-label')) {
            n.nodeValue = btn.getAttribute('data-idle-label');
            btn.removeAttribute('data-idle-label');
          }
        } else {
          if (!btn.hasAttribute('data-idle-label')) btn.setAttribute('data-idle-label', n.nodeValue);
          n.nodeValue = text;
        }
        return;
      }
    }
  }

  /* ── the add ──────────────────────────────────────────────── */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches('form.ths3-card-form')) return;

    var btn = form.querySelector('[data-card-atc], .card__atc');
    var card = form.closest('.card');

    ev.preventDefault();

    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      setLabel(btn, 'Adding…');
    }

    var addUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (item) {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.setAttribute('data-added', 'true');
          setLabel(btn, 'Added ✓');
          setTimeout(function () {
            btn.removeAttribute('data-added');
            setLabel(btn, null);
          }, 2000);
        }
        /* a short tap-confirm only — never a buzz on every interaction */
        if (navigator.vibrate && !reduced) { try { navigator.vibrate(10); } catch (e) {} }

        var img = card ? card.querySelector('.cardshow__img.cur, .card__media img') : null;
        var title = (item && item.product_title) || (card && card.querySelector('.card__name') ? card.querySelector('.card__name').textContent.trim() : '');
        var thumb = img ? img.currentSrc || img.src : null;

        /* Totals first, then paint — the panel shows a real subtotal rather than a
           bare confirmation. If /cart.js fails the panel still opens, just without
           the summary line; a network hiccup must not cost the buyer the CTA. */
        return refreshCount()
          .then(function (cart) {
            showToast({ title: title, image: thumb, cart: cart });
            return cart;
          })
          .catch(function () {
            showToast({ title: title, image: thumb });
          });
      })
      .catch(function (err) {
        /* Real failure states matter more than the happy path: sold
           out, inventory limits, or a network drop. Say what actually
           happened, then fall back to the native submit so the
           shopper is never stranded. */
        if (btn) {
          btn.removeAttribute('aria-busy');
          setLabel(btn, null);
        }
        var msg = (err && (err.description || err.message)) || 'Could not add that — please try again.';
        showToast({ error: true, message: String(msg).replace(/<[^>]*>/g, '') });
      });
  });

  /* ── header: get out of the way going down, come back going up ──
     A sticky header on a 390px phone costs ~12% of the viewport on
     every scroll. Hiding it while the shopper reads and returning
     it the moment they scroll up gives that back without removing
     access to search or cart. */
  (function () {
    var header = document.querySelector('header.site');
    if (!header) return;
    var last = window.scrollY, ticking = false;
    var THRESHOLD = 6;

    function update() {
      var y = window.scrollY;
      var delta = y - last;
      if (Math.abs(delta) > THRESHOLD) {
        /* never hide near the very top, and never while a menu or
           the search panel is open */
        var blocked =
          document.querySelector('[data-ths3-searchpanel]:not([hidden])') ||
          header.querySelector('[aria-expanded="true"]');
        if (delta > 0 && y > 220 && !blocked) header.classList.add('is-tucked');
        else header.classList.remove('is-tucked');
        last = y;
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      },
      { passive: true }
    );
  })();

  /* ── images fade in instead of popping ────────────────────────
     Product photography snapping in at full opacity is the single
     cheapest "unfinished" tell. Anything already cached is marked
     ready immediately so nothing ever fades on a repeat view. */
  (function () {
    if (reduced) return;
    var imgs = document.querySelectorAll('.card__media img, .ct__media img, .pdp__main img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      /* A card gallery stacks EVERY frame in the same box and shows one
         through .cur. This selector matches all of them, so the hidden
         frames were being faded up too: .ths-img-in[data-ready] scores
         (0,2,0) and beat .cardshow__img{opacity:0} at (0,1,0), leaving
         all five frames at opacity 1 with the LAST one in the DOM
         painting over the hero shot. On products whose final photo is a
         spec sheet, the grid showed an unreadable infographic instead of
         the product. It only bit on a COLD load — an already-cached image
         takes the `complete` branch below and never gets the class — which
         is why it hit first-time visitors and not us. Hidden frames are
         not animated at all now; the .cur one still fades in. */
      if (img.classList.contains('cardshow__img') && !img.classList.contains('cur')) continue;
      if (img.complete && img.naturalWidth) { img.setAttribute('data-ready', ''); continue; }
      img.classList.add('ths-img-in');
      img.addEventListener('load', function () { this.setAttribute('data-ready', ''); }, { once: true });
      img.addEventListener('error', function () { this.setAttribute('data-ready', ''); }, { once: true });
    }
  })();

  /* ── trust stats count up when they scroll into view ──────────
     The numbers were static text. ths3.js ships a count-up engine
     (§9) but it needs data-to/data-suffix attributes, and .stat__n
     renders a free-text Theme Editor field ("2,00,000+", "99%",
     "4.9★"), so it was never wired up — four big numbers sitting
     dead on the page.

     Parsing that free text here rather than in Liquid keeps the
     setting exactly as Manish types it. Two rules make this safe:
       · Indian digit grouping is preserved. The §9 engine groups
         Western-style, which would silently rewrite "2,00,000+"
         as "200,000+" — changing his content.
       · The final frame restores the ORIGINAL STRING byte for
         byte, so whatever he types is what ends up on screen,
         even if this parser misreads it.
     Anything non-numeric ("Handmade") is left completely alone. */
  (function () {
    var nums = document.querySelectorAll('.stat__n');
    if (!nums.length || !('IntersectionObserver' in window)) return;

    function groupIndian(intStr) {
      if (intStr.length <= 3) return intStr;
      var last3 = intStr.slice(-3);
      var rest = intStr.slice(0, -3);
      return rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    }
    function groupWestern(intStr) {
      return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function parse(el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)([\d][\d.,]*)(.*)$/);
      if (!m) return null;
      var digits = m[2];
      var plain = digits.replace(/,/g, '');
      var value = parseFloat(plain);
      if (!isFinite(value)) return null;

      var dot = plain.indexOf('.');
      var decimals = dot === -1 ? 0 : plain.length - dot - 1;
      /* "2,00,000" → groups after the first comma are 2 digits = Indian */
      var indian = /,\d{2},/.test(digits) || /^\d{1,2},\d{2},/.test(digits);

      return { raw: raw, prefix: m[1], suffix: m[3], value: value, decimals: decimals, indian: indian };
    }

    function render(spec, v) {
      var fixed = v.toFixed(spec.decimals);
      var parts = fixed.split('.');
      parts[0] = spec.indian ? groupIndian(parts[0]) : groupWestern(parts[0]);
      return spec.prefix + parts.join('.') + spec.suffix;
    }

    function run(el, spec) {
      if (reduced) { el.textContent = spec.raw; return; }
      var dur = 1500, t0 = null;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        if (p < 1) {
          el.textContent = render(spec, spec.value * eased);
          requestAnimationFrame(frame);
        } else {
          el.textContent = spec.raw;   /* authoritative final value */
        }
      }
      requestAnimationFrame(frame);
    }

    /* Parse at REGISTRATION, not at intersection. The authored string is
       only intact until something starts animating it, so reading it later
       is a hazard: a second count-up engine in ths3-motion.js used to fire
       on a later threshold, capture this animation's first eased frame
       ("0+") as its source value, and freeze the stat at zero on whichever
       device crossed the two thresholds in separate frames. That engine is
       gone; parsing up front means no future reader can be handed a
       half-animated number either. */
    var specs = [];
    for (var i = 0; i < nums.length; i++) {
      var spec = parse(nums[i]);
      if (!spec) continue;                    /* "Handmade" etc. — left alone */
      nums[i].setAttribute('data-ths3-counted', '');  /* one owner per element */
      nums[i]._ths3Stat = spec;
      specs.push(nums[i]);
    }
    if (!specs.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          var spec = el._ths3Stat;
          if (!spec) return;
          /* reserve the width so the row cannot reflow as digits grow */
          el.style.minWidth = el.getBoundingClientRect().width + 'px';
          el.style.display = 'inline-block';
          run(el, spec);
        });
      },
      { threshold: 0.4 }
    );
    for (var j = 0; j < specs.length; j++) io.observe(specs[j]);
  })();

  /* keep badges honest after a back/forward restore, where the
     rendered count can be from before the last add */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCount().catch(function () {});
  });
})();
